import { graphql } from "gql";

const GET_VULN_CODE_INFO = graphql(`
  query GetVulnCodeInfo($vulnId: String!) {
    vulnerability(uuid: $vulnId) {
      id
      isAutoFixable
      specific
      snippet {
        content
        offset
      }
    }
  }
`);

const GET_CUSTOM_FIX_SUBSCRIPTION = graphql(`
  subscription IntegratesGetCustomFix($vulnId: String!) {
    getCustomFix(vulnerabilityId: $vulnId)
  }
`);

const GET_REMEDIATION_LANGUAGES = graphql(`
  query GetRemediationLanguages(
    $groupName: String!
    $vulnerabilityId: String!
  ) {
    remediationLanguages(
      groupName: $groupName
      vulnerabilityId: $vulnerabilityId
    ) {
      fixes
    }
  }
`);

export {
  GET_VULN_CODE_INFO,
  GET_CUSTOM_FIX_SUBSCRIPTION,
  GET_REMEDIATION_LANGUAGES,
};
